export const APPRAISAL_EMBEDDED_MODULE = 'AppraisalMFE';
export const APPRAISAL_REFRESH_MODULE = 'AppraisalRefreshModule';
export const COMPOSER_MODULE = 'CarvanaComposerUi';
export const SOFTPULL_MODULE = 'SoftPullModule';

// Shared by useToggleModal (closes the modal) and useSoftpullGatedClick (clears a button's
// spinner) so both give up waiting for the Softpull MFE's ready signal after the same delay.
export const SOFTPULL_READY_FAILSAFE_MS = 10000;
